import axios from 'axios';

export const apiRoutes = {

  //Member
  MemberInformation: window.tlf_backend_url + "/frontend/member/information", //Get - Gets the members information
  MemberTickets: window.tlf_backend_url + "/frontend/member/ticket", //Get - Gets the members tickets
  OrderHistory: window.tlf_backend_url + "/frontend/member/orders/history", //Get - Gets the members order history
  //MemberContactInfo: window.tlf_backend_url + "/frontend/member/contactinfo", //Put - Updates members physical address information
  UserWinHistory: window.tlf_backend_url + "/frontend/member/settings/winner/history", //Get - Gets the members win history
  UserHistory: window.tlf_backend_url + "/frontend/member/orders/summary", //Get - Gets the members purchase/registration history
  MemberUnsubscribe: window.tlf_backend_url + "/frontend/member/settings/email/unsubscribe", //Put - Updates members email subscription settings
  ChangePassword: window.tlf_backend_url + "/frontend/member/settings/password", //Post - Updates members password
  UpdateUserInformation: window.tlf_backend_url + "/frontend/member/settings/information", //Put - Updates members personal information
  EmailConfirmationResend: window.tlf_backend_url + "/frontend/member/authentication/resend", //Get - Resends the email confirmation
  ForgotPassword: window.tlf_backend_url + "/frontend/member/authentication/email/forgot", //Post - Sends the member an email to reset their password
  PasswordReset: window.tlf_backend_url + "/frontend/member/authentication/email/password/reset", //Post - Updates the members password when the member forgot theirs
  SetInitialEmail: window.tlf_backend_url + "/frontend/member/authentication/email/setInitialEmail", //Post - Sets the members initial email
  EmailMemberUnsubscribe: '/frontend/member/unsubscribe', //Put - Unsubscribes the member from all emails after member clicks on unsubscribe in email
  MemberUpdate: window.tlf_backend_url + "/frontend/member", //Patch - Updates the members information

  //Site
  SiteDetails: window.tlf_backend_url + "/frontend/site/details", //Get - Gets the site details
  SiteWinners: window.tlf_backend_url + "/frontend/site/winners", //Get - Gets list of previous winners
  SiteDrawSponsor: window.tlf_backend_url + "/frontend/site/sponsor", //Get - Gets the current draw sponsor

  //Draws
  AdditionalDraws: window.tlf_backend_url + "/frontend/site/organization/next/draw/additional", //Get - Gets the additional draws for the organization
  
  //organization
  OrganizationContactInformation: window.tlf_backend_url + "/frontend/site/organization/address", //Get - Gets the organizations contact information
  OrganizationUpcomingDraws: window.tlf_backend_url + "/frontend/site/organization/draws", //Get - Gets the upcoming draws
  OrganizationNextDraw: window.tlf_backend_url + "/frontend/site/organization/nextdraw", //Get - Gets the detials of the next draw
  OrganizationDrawById: window.tlf_backend_url + "/frontend/site/organization/draw", //Get - Gets a specific draw by ID
  OrganizationPurchasePlans: window.tlf_backend_url + "/frontend/site/organization/plans", //Get - Gets the purchase plans
  OrganizationContent: window.tlf_backend_url + "/frontend/site/organization/content", //Get - Gets the organizations content

  //Login
  EmailLogin: window.tlf_backend_url + "/frontend/member/authentication/email/login", //Post - Logs in the member via Email and Password

  //Refresh
  RefreshToken: window.tlf_backend_url + "/frontend/member/authentication/refresh", //Post - Refreshes the members token

  //Register
  EmailRegister: window.tlf_backend_url + "/frontend/member/authentication/email/register", //Post - Registers a new member via Email and Password
  ConfirmEmail: window.tlf_backend_url + "/frontend/member/email/confirm", //Put - Confirms the members email
  FinalizeAccount: window.tlf_backend_url + "/frontend/member/authentication/email/finalize", //Put - Finalizes the members account

  //Purchase
  MinimumPurchase: window.tlf_backend_url + "/frontend/site/purchase/minimum", //Get - Gets the minimum purchase amount
  CheckPurchaseLimitations: window.tlf_backend_url + "/frontend/member/cart/limitations", //Get - Checks the org purchase limitations
  CtaPickACard: window.tlf_backend_url + "/frontend/site/pickacard", //Get - Gets the current deck of cards
  AddToCart: window.tlf_backend_url + "/frontend/member/cart/add", //Post - Adds item(s) to the members cart

  //Checkout
  InitializeCheckout: window.tlf_backend_url + "/frontend/member/checkout/initialize", //Post - Initializes checkout with multi-provider support
  PaymentProviderInfo: window.tlf_backend_url + "/frontend/member/checkout/provider", //Get - Gets payment provider info for the organization
  WorldPayProcessPayment: window.tlf_backend_url + "/frontend/member/checkout/worldpay/process", //Post - Processes a WorldPay payment after SDK completion
  MonerisProcessPayment: window.tlf_backend_url + "/frontend/member/checkout/moneris/process", //Post - Processes a Moneris payment after SDK completion
  AdyenProcessPayment: window.tlf_backend_url + "/frontend/member/checkout/adyen/process", //Post - Processes Adyen component payment submission
  AdyenProcessDetails: window.tlf_backend_url + "/frontend/member/checkout/adyen/details", //Post - Processes Adyen additional details/3DS challenge completion
  AdyenVerifyPayment: window.tlf_backend_url + "/frontend/member/checkout/adyen/verify", //Post - Legacy Adyen verification endpoint
  PayPalConfirm: window.tlf_backend_url + "/frontend/member/checkout/paypal/confirm", //Post - Captures a PayPal order after approval
  FiservProcessPayment: window.tlf_backend_url + "/frontend/member/checkout/fiserv/process", //Post - Processes a Fiserv payment after session tokenization
  NorthProcessPayment: window.tlf_backend_url + "/frontend/member/checkout/north/process", //Post - Processes a North payment after tokenization
  StripePaymentIntent: window.tlf_backend_url + "/frontend/member/checkout/payment/stripe/intent", //Post - Creates a payment intent for stripe (legacy)
  CartSummary: window.tlf_backend_url + "/frontend/member/cart/summary", //Get - Gets the members cart summary
  Cart: window.tlf_backend_url + "/frontend/member/cart", //Get - Gets the members cart items
  CheckoutDropdownFields: window.tlf_backend_url + "/frontend/site/checkout/userdefined/fields", //Get - Gets the checkout dropdown question(s)
  CheckoutDropdownFieldsTitle: window.tlf_backend_url + "/frontend/site/checkout/userdefined/Title", //Get - Gets the checkout dropdown title
  ClearCart: window.tlf_backend_url + "/frontend/member/cart/clear", //Delete - Clears the members cart
  CheckBillingAgainstGeo: window.tlf_backend_url + "/frontend/member/checkout/purchase/geo/billinginfo", //Get - Checks the members billing address against the geo location settings
  TicketTrackingFields: window.tlf_backend_url + "/frontend/site/ticket/tracking/field", //Get - Gets the ticket tracking fields
  TicketTrackingOptions: window.tlf_backend_url + "/frontend/site/ticket/tracking/entry", //Get - Gets the ticket tracking entries
  TicketTrackingUpdate: window.tlf_backend_url + "/frontend/member/ticket/tracking", //Post - Updates the members ticket tracking

  //Purchase Receipt
  CurrentPurchaseReceipt: window.tlf_backend_url + "/frontend/member/orders/current/receipt", //Get - Gets the members purchase receipt
  PurchaseReceipt: window.tlf_backend_url + "/frontend/member/orders/receipt", //Get - Gets the members purchase receipt
  ResendPurchaseReceipt: window.tlf_backend_url + "/frontend/member/orders/purchase/receipt/resend", //Get - Resends the members purchase receipt

  //Ticket Tracking
  TicketTrackingPartners: window.tlf_backend_url + "/frontend/site/organization/partners", //Get - Gets the ticket tracking partners for the organization

  //Access
  LocationAccess: window.tlf_backend_url + "/frontend/site/organization/location/access", //Get - Gets the members location access
}

const instance = axios.create({
  baseURL: window.tlf_backend_url
})

instance.interceptors.request.use(
  config => {
    const token = localStorage.getItem('access_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  error => Promise.reject(error)
)

export default instance